import { Board } from "@sportactics/board-editing";
import { createContext } from "react";

import { LazyValue, useLazyContext } from "~utils";

export function useWebShare(): useWebShareReturn {
  return useLazyContext(WebShareContext);
}

export const WebShareContext =
  createContext<LazyValue<useWebShareReturn>>(undefined);

// The methods stay optional, unlike every other port: the browser may have no Web
// Share API, so their absence is a capability the device lacks rather than a
// provider that has not mounted. Reaching the port itself is what is now guaranteed.
export type useWebShareReturn = {
  shareFormation?: (formation: Board, url: string) => Promise<void>;
  shareScreenshot?: (image: File) => Promise<void>;
};
